import { render, staticRenderFns } from "./IpDetails.vue?vue&type=template&id=719533b0&"
import script from "@/scripts/components/column/ipDetails.js?vue&type=script&lang=js&"
export * from "@/scripts/components/column/ipDetails.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports